import React, { useState, useEffect, useRef, useContext } from "react";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { confirmDialog } from "primereact/confirmdialog";

import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";
import { useForm } from "../../../../Base/Hooks/useForm";

import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import Loader from "../../../../Base/Components/Loader/Loader";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";

import { getEstadosCategory } from "../../../../API/Global/Status/StatusRequests";
import { toastShow } from "../../../../Base/Services/ToastService";
import { EliminarSubConstrucciones, getSubConstrucciones, GuardarSubConstruccion } from "../../../../API/Global/Construcciones/ConstruccionesRequest";
import { Dropdown } from "primereact/dropdown";

const SubconstruccionesCRUD = ({ showDialog, setShowDialog }) => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);

  const getValoresIniciales = async (rowsSinGuardados) => {
    setLoading(true)
    const estadosTempo = await getEstadosCategory("General");
    setEstados(estadosTempo?.filter((i) => i?.IdStatus !== 7));

    const dataTempo = await getSubConstrucciones()
    let result = dataTempo
    if(rowsSinGuardados){
        result = [...dataTempo, ...rowsSinGuardados]
    }
    setData(result)
    setLoading(false)
  };

  const NuevaFila = () => {
    let dataNueva = {
      IdSubConstruccion: -(data.length + 1),
      SubConstruccion: null,
      IdStatus: 5,
      StatusName: "Activo",
      Descripcion: null,
      rowEdit: true,
    };

    let nuevoArreglo = data.concat([dataNueva]);
    setData(nuevoArreglo);
  };

  const AsignarInformacion = (row) => {
    let tempo = [...data];
    const index = tempo.findIndex((t) => t.IdSubConstruccion === row?.IdSubConstruccion);
    tempo[index] = row;
    setData(tempo);
  };

  const RemoverFila = () => {
    if (selected.length > 0) {
      let rowsValidos = selected.filter((s) => s.IdSubConstruccion < 0);
      if (rowsValidos.length > 0) {
        let listadoFinal = data.filter((l) =>!rowsValidos.some((s) => s.IdSubConstruccion === l.IdSubConstruccion));
        setData(listadoFinal);
      } else {
        toastShow( toast, "error", "Solo se pueden remover filas nuevas", "Cambie el estado de las subconstrucciones que desea cambiar" );
      }
    } else {
      toastShow(toast, "error", 'Error', "Debe seleccionar la fila que desea remover");
    }
  };
  
  const VerificarInformacion = () => {
    let erros = {}
    let isValid = true

    let sinNombre = data.find((d) => (d.SubConstruccion)?.trim()?.length === 0 || d.SubConstruccion === null)
    if (sinNombre) {
        toastShow(toast, 'error', 'Error', 'Debe ingresar el nombre de la SubConstrucccion')
        return false
    } else {
        return true
    }
  }
  
  const GuardarInformacion = () => {
    const verificacion = VerificarInformacion()
    if (verificacion) {
        setLoading(true)
        let message = <div>¿Está seguro que desea guardar la información?</div>
        confirmDialog({
            message:message,
            header: 'Confirmación',
            icon: 'pi pi-exclamation',
            accept:async()=>{
                let rowsEnviar = data.filter((d)=> d?.rowEdit)
                if(rowsEnviar.length >0){
                    let result = await GuardarSubConstruccion(rowsEnviar)
                    if(result.length > 0){
                        if(result[0]?.ERROR !== 0){
                            toastShow(toast, 'success','Guardada', result[0]?.MSJ)
                            getValoresIniciales()
                        }else{
                            toastShow(toast, 'error','Error', result[0]?.MSJ)
                        }
                    }else{
                        toastShow(toast, 'error', 'Error','Ocurrio un error al querer guardar la información')
                    }
                }else{
                    getValoresIniciales()
                }
            },
            reject:()=>{}

        })
        setLoading(false)
    } else {
        toastShow(toast, 'error', 'Error','Error','Ingrese la informacion Correctamente')
    }
  }

  const changeEstado = ({ data, api }) => {
    return (
      <div>
        <Dropdown
          value={estados.filter((e) => e.IdStatus === data.IdStatus)[0]}
          options={estados}
          optionLabel="StatusName"
          filter
          filterBy="StatusName"
          style={{ width: "100%" }}
          onChange={(e) => {
            let changes = [];
            if (selected.length > 0) {
              changes = selected.map((item) => {
                return {
                  IdSubConstruccion: item.IdSubConstruccion,
                  IdStatus: e.value.IdStatus,
                  StatusName: e.value.StatusName,
                };
              });
            } else {
              changes.push({
                IdSubConstruccion: data.IdSubConstruccion,
                IdStatus: e.value.IdStatus,
                StatusName: e.value.StatusName,
              });
            }
            confirmDialog({
              message: `¿Cambiar a estado ${e.value.StatusName} a ${changes.length}  ${changes.length > 1 ? 'SubConstrucciones' : 'SubConstrucción' } ?`,
              header: "Confirmación",
              icon: "pi pi-exclamation-triangle",
              accept: async () => {
                let rowsGuardados = changes.filter((item) => item.IdSubConstruccion > 0);
                let rowsSinGuardados = changes.filter((item) => item.IdSubConstruccion < 0);
                let IdSubConstrucciones = rowsGuardados.map((item) => item.IdSubConstruccion);
                if(IdSubConstrucciones.length > 0){
                  cambiarEstado(e.value.IdStatus, IdSubConstrucciones.toString());
                }
                getValoresIniciales(rowsSinGuardados);
                api.stopEditing();
              },
              reject: () => {},
            });
          }}
        />
      </div>
    );
  };
  
  const cambiarEstado = async (IdStatus, IdSubConstrucciones) => {
    const result = await EliminarSubConstrucciones({ IdStatus, IdSubConstrucciones });
    toastShow(toast, "success", "Actualizado", "Estado cambiado exitosamente");
    setSelected([]);
  };

  const columns = [
    {
      field: "IdSubConstruccion",
      header: "ID",
      headerEn: "ID",
      className: "Xsmall",
      hidden: userAuth?.IdRol === 1,
    },
    {
      field: "SubConstruccion",
      header: "SubConstruccion",
      headerEn: "Sub-Construction",
      className: "XXXlarge",
      flex: 1,
      editable: true,
      Sumary: "count",
      onChange: (rowData) => {
        let row = rowData?.data;
        if (row) {
          row.rowEdit = true;
          row.IdUserEdit = userAuth?.IdUser;
          AsignarInformacion(row);
        }
      },
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      className: "small",
      Format: "Estado",
      body: (rowData) => ({
        ID: rowData.IdStatus,
        Estado: rowData.StatusName,
      }),
      editable: true,
      cellEditor: changeEstado,
    },
    // {
    //   field: "StatusName",
    //   header: "Estado",
    //   headerEn: "Status",
    //   className: "small",
    //   editable: true,
    //   Format: "AutoComplete",
    //   value: "IdStatus",
    //   label: "StatusName",
    //   items: estados,
    //   onChange: ({
    //     state,
    //     data: rowData,
    //     value,
    //     label,
    //     api,
    //     items,
    //     oldValue,
    //   }) => {
    //     let row = { ...rowData };
    //     if (row) {
    //       row.rowEdit = true;
    //       row.IdUserEdit = userAuth?.IdUser;
    //       AsignarInformacion(row);
    //     }
    //   },
    // },
    {
      field: "Descripcion",
      header: "Descripción",
      headerEn: "Description",
      className: "XXlarge",
      editable: true,
      onChange: ({
        state,
        data: rowData,
        value,
        label,
        api,
        items,
        oldValue,
      }) => {
        let row = { ...rowData };
        if (row) {
          row.rowEdit = true;
          row.IdUserEdit = userAuth?.IdUser;
          AsignarInformacion(row);
        }
      },
    },
  ];

  const table = {
    Data: data,
    selected: selected,
    setSelected: setSelected,
    Columns: columns,
  };

  useEffect(() => {
    if (showDialog) {
      getValoresIniciales();
    }
  }, [showDialog]);

  return (
    <div>
      <Dialog
        visible={showDialog}
        style={{ width: "55vw", height: "95vh" }}
        onHide={() => {
          setShowDialog(false);
          setSelected([]);
        }}
        header={getLabel(baseLang, "tituloSubConstrucciones", config?.language)}
      >
        <Loader loading={loading} querySelector={"#ListadoSubConstruccion"} />
        <Toast ref={toast} />
        <div className="d-flex gap" style={{ alignItems: "center" }}>
          <Button icon="pi pi-plus" onClick={() => NuevaFila()} />
          <Button icon="pi pi-refresh" onClick={() => getValoresIniciales()} />
          <Button
            icon="pi pi-save"
            onClick={() => GuardarInformacion()}
            loading={loading}
          />
          <Button
            icon="pi pi-times"
            severity="danger"
            onClick={() => RemoverFila()}
          />
        </div>
        <div
          className="pt-4"
          style={{ height: "76vh" }}
          id="ListadoSubConstruccion"
        >
          <AgGrid table={table} />
        </div>
      </Dialog>
    </div>
  );
};

export default SubconstruccionesCRUD;
